// extracted by mini-css-extract-plugin
var _1 = "ApplicantCreditCheckVerdictModalField-moduleextractedChip__hjONF";
var _2 = "ApplicantCreditCheckVerdictModalField-moduleextractedField__FQSXu";
export { _1 as "extractedChip", _2 as "extractedField" }
